/**
 * Pijltjes naast een sectietitel die de Horizon-carousel in dezelfde sectie bedienen
 * (zoals bij "Nieuwe Items" en "Collecties" in het vorige thema).
 */
class MmCarouselNav extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-mm-carousel]');
    if (!button) return;

    const slideshow = this.closest('.shopify-section')?.querySelector('slideshow-component');
    if (!slideshow) return;

    const direction = button.getAttribute('data-mm-carousel');
    if (direction === 'previous' && typeof slideshow.previous === 'function') slideshow.previous(event);
    if (direction === 'next' && typeof slideshow.next === 'function') slideshow.next(event);
  };
}

if (!customElements.get('mm-carousel-nav')) {
  customElements.define('mm-carousel-nav', MmCarouselNav);
}
